import React, {useState, useEffect } from 'react';
import './App.css';
import OthersIdeas from './OthersIdeas'
import AddTekst from './AddTekst'
import {db} from './firebase'
import { act } from '@testing-library/react';
import firebase from './firebase';
import {BrowserRouter as Router, Switch, Route, useHistory, Link } from "react-router-dom";
import {selectDeafultActors} from './features/deafultActorsSlice';
import {useSelector} from "react-redux";
import {addActor} from './features/addedActorsSlice';
import { useDispatch } from 'react-redux';
import DefaultComedy from './DefaultComedy';
import CustomComedy from './CustomComedy';
import FancyTitle from './FancyTitle';
import GenerateComedy from './GenerateComedy';


function App() {

  return (
    <div className="app">
            <FancyTitle />
          <div className="dodawanieTekstuIScenariuszILink">
              <OthersIdeas />
              <AddTekst />
              <Router>
                <Switch>
                <Route path="/">
                   <GenerateComedy />
                  </Route>
                </Switch>
              </Router >
          </div>
    </div>
  );
}

export default App;
